<template>
  <div class="timeline-skeleton mb-24">
    <BittsBone
      type="heading"
      :height="24"
      class="w-80 mb-12 ml-[-8px]"
      shimmer="slow"
    />
    <BittsBone
      v-for="num in 4"
      :key="num"
      :height="24"
      :width="50"
      class="h-16 ml-12 mb-16"
      shimmer="slow"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsBone } from '@crossbeam/bitts';
</script>
